import { StudyGroupQuery } from '../../../../../../generated/graphqlModels';
import { axiosWrapper } from '../../../../../../hooks/axios';

const createEditorUser = async (
  studyGroupPk: string,
  user: StudyGroupQuery['studyGroup']['students'][number],
) => {
  const request = await axiosWrapper(
    `/api/v1/records/study_groups/${studyGroupPk}/editor_users/`,
    'post',
    user,
  );
  return request.data;
};

export default createEditorUser;
